module.exports = __webpack_public_path__ + "static/media/seller-empty.71e76a3b.svg";